import { apiBaseUrl } from "./config"
import { getBaseHeader } from "./utils"
import { genericFetch }  from './common-service'
import { LocalAuthority, Observation } from "../../model"
import { createObservationRequestBody, createUpdateObservationRequestBody } from '../../service/sfp/factory'
import ApiError, { ApiErrorCode }      from "../../error/api-error"

const LOCALAUTHORITIES = 'localauthorities'
const OBSERVATIONS     = 'observations'

export function createObservation(
	localAuthority: LocalAuthority,
	observation   : Observation
): Promise<Observation> {
	const observationRB = createObservationRequestBody(observation)
	const body = JSON.stringify(observationRB)
	const url  = `${apiBaseUrl}/${LOCALAUTHORITIES}/${localAuthority.slug}/${OBSERVATIONS}`
	const init = {
		body,
		headers: { ...getBaseHeader(), 'Content-Type': 'application/json' },
		method: "POST"
	} as RequestInit

	return fetch(url, init).then(response => {
		switch (response.status) {
			case 200:
				return response.json().then(result => result as Observation)
			case 404:
				throw new ApiError(ApiErrorCode.NotFound, "Le compte de cette collectivité n'existe pas.")
			case 409:
				throw new ApiError(ApiErrorCode.Conflict, "Le compte pour cette collectivité existe déjà.")
			case 422:
				throw new ApiError(ApiErrorCode.Conflict, "Un problème est survenu.")
			}
		throw new Error("Unexpected error.")
	})
}

export function deleteObservation(
	localAuthority: LocalAuthority,
	observation: Observation
	): Promise<void> {

	const url: string = `${apiBaseUrl}/${LOCALAUTHORITIES}/${localAuthority.slug}/${OBSERVATIONS}/${observation.id}`
	return genericFetch<void>(url, { headers: getBaseHeader(), method: "DELETE" })
}

export function updateObservation(localAuthority: LocalAuthority, observation: Observation): Promise<Observation> {
	const url: string = `${apiBaseUrl}/${LOCALAUTHORITIES}/${localAuthority.slug}/${OBSERVATIONS}/${observation.id}`
	const lacaRB = createUpdateObservationRequestBody(observation)
	const headers: HeadersInit = {
		...getBaseHeader(),
		"Content-Type": "application/json"
	}
	const body: string = JSON.stringify(lacaRB)
	const init: RequestInit = {
		body,
		headers,
		method: "PUT"
	}

	return genericFetch<Observation>(url, init)
}



// WEBPACK FOOTER //
// ./src/service/sfp/observations-service-2.ts